import React, { useEffect, useMemo } from 'react';
import { ShowTitle } from '../show-title';
import { ActiveBgColor } from '../active-bg-color';
import { PHYSICAL_CONDITION_ITEMS } from '../physical-condition';
import {
  setCurrentStep,
  setFormValue,
  setNextBtnConfig,
  setPrevBtnConfig,
  useAIDiagnoseStore,
} from '../../store/useAIDiagnoseStore';

import cx from './index.module.scss';

interface Props {}

export const PHYSICAL_CONDITION_LEVELS = [
  {
    name: '轻度',
    extraFieldsName: '从不',
    level: 2,
  },
  {
    name: '中度',
    extraFieldsName: '偶尔',
    level: 3,
  },
  {
    name: '重度',
    extraFieldsName: '经常',
    level: 4,
  },
];

const PHYSICAL_CONDITION_LEVELS_2_COLOR_LEVEL = {
  2: 1,
  3: 3,
  4: 5,
};

export const PhysicalConditionLevel: React.FC<Props> = () => {
  const { physicalCondition, physicalConditionLevel } = useAIDiagnoseStore.use.formValue();

  const renderBgLevel = useMemo(() => {
    if (!physicalConditionLevel) return null;

    // 渲染的背景图片的等级取决于选择的最大严重等级
    return Math.max.apply(
      null,
      Object.values(physicalConditionLevel)?.map(item => PHYSICAL_CONDITION_LEVELS_2_COLOR_LEVEL[item])
    ) as AIDiagnose.PainLevel;
  }, [physicalConditionLevel]);

  useEffect(() => {
    setPrevBtnConfig({
      show: true,
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev - 1 }));
      },
    });

    setNextBtnConfig({
      disable: [...physicalCondition, 'stayUpLate']?.some(item => !physicalConditionLevel?.[item]),
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev + 1 }));
      },
    });
  }, [physicalCondition, physicalConditionLevel]);

  return (
    <div className={cx('PhysicalConditionLevel')}>
      <ShowTitle title="您的体质情况" subTitle="让我们更了解您的体质，更好的为您做出判断" />
      <div className={cx('content')}>
        <div className={cx('condition-level-wrapper')}>
          {physicalCondition
            // 表单排序
            ?.sort(
              (a, b) =>
                Object.keys(PHYSICAL_CONDITION_ITEMS)?.indexOf(a) - Object.keys(PHYSICAL_CONDITION_ITEMS)?.indexOf(b)
            )
            ?.map(item => (
              <div key={item} className={cx('condition-level-item')}>
                <div className={cx('label')}>{PHYSICAL_CONDITION_ITEMS[item]?.name}</div>
                <div className={cx('selector')}>
                  {PHYSICAL_CONDITION_LEVELS.map(item2 => (
                    <div
                      onClick={() =>
                        setFormValue(
                          {
                            physicalConditionLevel: {
                              [item]: item2?.level,
                            },
                          },
                          {
                            isMerge: true,
                          }
                        )
                      }
                      className={cx('selector-item', { active: physicalConditionLevel?.[item] === item2?.level })}
                      key={item2.name}
                    >
                      {item2.name}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          <div key="stayUpLate" className={cx('condition-level-item')}>
            <div className={cx('label')}>您的熬夜情况</div>
            <div className={cx('selector')}>
              {PHYSICAL_CONDITION_LEVELS.map(item2 => (
                <div
                  onClick={() =>
                    setFormValue(
                      {
                        physicalConditionLevel: {
                          stayUpLate: item2?.level as any,
                        },
                      },
                      {
                        isMerge: true,
                      }
                    )
                  }
                  className={cx('selector-item', { active: physicalConditionLevel?.['stayUpLate'] === item2?.level })}
                  key={item2.extraFieldsName}
                >
                  {item2.extraFieldsName}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <ActiveBgColor level={renderBgLevel} imgTop={-55} />
    </div>
  );
};
